import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ListingViewItemComponent } from '../listing-view-item.component';
import * as models from '../../../buyer/interfaces/model';
import { environment } from '../../../../environments/environment';
import { NotificationFiltersEnum } from '../../interfaces/INotificationDetail';
import { CurrentDealPipe } from '../../pipes/current-deal.pipe';
import { CustomCurrencyPipe } from '../../pipes/currency.pipe';
import { OnlyDigitsDirective } from '../../directives/only-digits.directive';
import { FormsModule } from '@angular/forms';
import { PastPurchaseTitleMobileComponent } from '../../past-purchase-title/past-purchase-title-mobile/past-purchase-title-mobile.component';
import { NgIf, NgClass, NgFor, CurrencyPipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-listing-view-item-mobile',
    templateUrl: './listing-view-item-mobile.component.html',
    styleUrls: ['./listing-view-item-mobile.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, PastPurchaseTitleMobileComponent, NgClass, NgFor, FormsModule, OnlyDigitsDirective, CurrencyPipe, DatePipe, CustomCurrencyPipe, CurrentDealPipe]
})
export class ListingViewItemMobileComponent extends ListingViewItemComponent implements OnInit {
  @Input() item: models.IItem;
  @Input() source = '';
  @Input() currentNotFilter: NotificationFiltersEnum;
  @Output() notificationTooltipEmitter = new EventEmitter<{ item: models.IItem, event: Event }>();
  @Output() gradGuideEmitter = new EventEmitter<models.IItem>();
  @Output() offerPopupEmitter = new EventEmitter<models.IItem>();
  isDetailsOpened = false;
  isShowPackageDescription = false;
  environment = environment;
  showItemMXQ = false;

  toggleDetails(event: Event, shouldClose: boolean): void {
    this.isDetailsOpened = shouldClose ? false : !this.isDetailsOpened;
    this.isShowPackageDescription = false;
  }

  showDetails() {
    this.isDetailsOpened = true;
  }
  hideDetails() {
    this.isDetailsOpened = false;
    this.isShowPackageDescription = false;
  }

  getAttrUrl(attr) {
    switch (attr.label) {
      case 'Price Drop' :
        return '../../../../assets/images/icons/mobile/24-price-drop.svg';
      case 'Just Launched' :
        return '../../../../assets/images/icons/mobile/24-just-lauched.svg';
      case 'Today\'s Deals' :
        return '../../../../assets/images/icons/mobile/24-todays-deals.svg';
      default :
        return false;
    }
  }

  isTopAttributes(attr): boolean {
    const topAttrArr = attr.filter((attr) => attr.label === 'Just Launched'
      || attr.label === 'Today\'s Deals' || attr.label === 'Price Drop');
    return topAttrArr.length > 0;
  }

  showGradingGuide(event: any): void {
    event.preventDefault();
    event.stopPropagation();
    this.gradGuideEmitter.emit(this.item);
  }

  qtyInputClicked(element:any): void{
    if (element){
      this.item.qty = null;
      element.focus();
      element.select();
    }
  }

  triggerPackageDescription(event: any): void {
    event.preventDefault();
    event.stopPropagation();
    if (event.isTrusted) {
      this.isShowPackageDescription = !this.isShowPackageDescription;
    }
  }

  toggleSimilar (item: models.IItem, event:any): void {
    event.preventDefault();
    event.stopPropagation();
    if (event.isTrusted) {
      this.itemsService.fetchSimilarItems(item);
    }
  }

  itemMXQTooltip() {
    this.showItemMXQ = !this.showItemMXQ;
  }

  openOfferModal(event: any): void {
    this.offerPopupEmitter.emit(this.item);
  }

}


